import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import { Card } from 'reactstrap';
import Spinner from '~/components/spinner/spinner';
import URLParamBanner from '~/components/urlParamBanner/urlParamBanner';
import ErrorBoundaryContent from '~/components/errorBoundary/content';

export const getLocationsQuery = gql`
  query locations($breweryId: Int!) {
    locations(breweryId: $breweryId) {
      id
      name
    }
  }
`;

const LocationsList = ({ brewery, history }) => (
  <Query query={getLocationsQuery} variables={{ breweryId: brewery.id }}>
    {props => {
      const { loading, error, data } = props;
      if (loading) {
        return <Spinner className="absolute absolute-center stroke-brand-red" />;
      }

      if (error) {
        return <ErrorBoundaryContent error={error} />;
      }

      return (
        <Fragment>
          <URLParamBanner name="location" />
          <Card className="content">
            <table className="table mb0">
              <thead>
                <tr>
                  <th className="bt-n bb-n">Name</th>
                </tr>
              </thead>
              <tbody>
                {data.locations.map(location => (
                  <tr
                    className="table-row pointer"
                    key={location.id}
                    onClick={() => {
                      history.push(`/settings/locations/${location.id}`);
                    }}
                  >
                    <td>
                      <strong>{location.name}</strong>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Card>
        </Fragment>
      );
    }}
  </Query>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(withRouter(LocationsList));



// WEBPACK FOOTER //
// ./src/containers/locationsList/locationsList.jsx